const translation = {
  es: {
    validations: {
      required: "No puede estar vacío",
      minLength: "Debe tener al menos",
      maxLength: "El máximo de caracteres permitidos es",
      minValue: "Debe ser al menos",
      maxValue: "No puede ser mayor a",
      integer: "Debe de ser un numero",
      decimal: "Debe ser un numero decimal",
      email: "Debe ser un correo",
      characters: "caracteres",
    },
  },
  en: {
    validations: {
      required: "Cannot be empty",
      minLength: "Should be at least",
      maxLength: "Maximum characters allowed is",
      minValue: "Must be at least",
      maxValue: "Cannot be greater than",
      integer: "Must be a number",
      decimal: "Must be a decimal number",
      email: "Has to be email",
      characters: "characters",
    },
  },
};
export default translation;
